<template>
  <div id="loader" v-if="visible">
    <div class="load-close-btn" @click="off">
      <i class="fa fa-times"></i>
    </div>
    <!--
      <div class="loader"></div>
    -->
    <div class="flex-spinner">
      <div>
        <component
          :is="spinner"
          :animation-duration="1000"
          :size="120"
          :color="'#fff'"
        />
      </div>
    </div>
    <h4 class="load-text">{{ title }}&hellip;</h4>
  </div>
</template>
<script>
  import {
    FlowerSpinner,
    PixelSpinner,
    HollowDotsSpinner,
    IntersectingCirclesSpinner,
    OrbitSpinner,
    RadarSpinner,
    ScalingSquaresSpinner,
    HalfCircleSpinner,
    TrinityRingsSpinner,
    FulfillingSquareSpinner,
    CirclesToRhombusesSpinner,
    SemipolarSpinner,
    SelfBuildingSquareSpinner,
    SwappingSquaresSpinner,
    FulfillingBouncingCircleSpinner,
    FingerprintSpinner,
    SpringSpinner,
    AtomSpinner,
    LoopingRhombusesSpinner,
    BreedingRhombusSpinner
  } from 'epic-spinners'
  import event from '../../event'
  export default {
    name: 'Loading',
    data () {
      return {
        visible: false,
        title: 'Loading',
        spinners: [
          'FlowerSpinner',
          'PixelSpinner',
          'HollowDotsSpinner',
          'IntersectingCirclesSpinner',
          'OrbitSpinner',
          'RadarSpinner',
          'ScalingSquaresSpinner',
          'HalfCircleSpinner',
          'TrinityRingsSpinner',
          'FulfillingSquareSpinner',
          'CirclesToRhombusesSpinner',
          'SemipolarSpinner',
          'SelfBuildingSquareSpinner',
          'SwappingSquaresSpinner',
          'FulfillingBouncingCircleSpinner',
          'FingerprintSpinner',
          'SpringSpinner',
          'AtomSpinner',
          'LoopingRhombusesSpinner',
          'BreedingRhombusSpinner'
        ],
        spinner: 'FlowerSpinner'
      }
    },
    components: {
      FlowerSpinner,
      PixelSpinner,
      HollowDotsSpinner,
      IntersectingCirclesSpinner,
      OrbitSpinner,
      RadarSpinner,
      ScalingSquaresSpinner,
      HalfCircleSpinner,
      TrinityRingsSpinner,
      FulfillingSquareSpinner,
      CirclesToRhombusesSpinner,
      SemipolarSpinner,
      SelfBuildingSquareSpinner,
      SwappingSquaresSpinner,
      FulfillingBouncingCircleSpinner,
      FingerprintSpinner,
      SpringSpinner,
      AtomSpinner,
      LoopingRhombusesSpinner,
      BreedingRhombusSpinner
    },
    watch: {
      visible (newVal, oldVal) {
        if (newVal) {
          this.spinner = this.spinners[(Math.ceil(Math.random() * this.spinners.length)) - 1]
        }
      }
    },
    methods: {
      on (data) {
        if (typeof data === 'object' && data.hasOwnProperty('title')) {
          this.title = data.title
        }
        this.visible = true
      },
      off () {
        this.visible = false
        this.title = 'Loading'
      }
    },
    mounted () {
      event.$on('loading-on', this.on)
      event.$on('loading-off', this.off)
    }
  }
</script>

<style>
  .flex-spinner {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 75px;
    margin-bottom: 10px;
  }
  .load-close-btn {
    position: fixed;
    top: 10px;
    right: 10px;
  }
  .load-close-btn i {
    font-size: 30px;
    color: #fff;
  }
  .load-text {
    text-align: center;
    color: #fff;
    opacity: 0.9;
    margin-top: 10px;
  }
  #loader {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.5);
  }
  .loader,
  .loader:before,
  .loader:after {
    border-radius: 50%;
  }
  .loader {
    color: #ffffff;
    font-size: 11px;
    text-indent: -99999em;
    margin: 200px auto 0px auto;
    position: relative;
    width: 10em;
    height: 10em;
    box-shadow: inset 0 0 0 1em;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
  }
  .loader:before,
  .loader:after {
    position: absolute;
    content: '';
  }
  .loader:before {
    width: 5.2em;
    height: 10.2em;
    background: #000;
    border-radius: 10.2em 0 0 10.2em;
    top: -0.1em;
    left: -0.1em;
    -webkit-transform-origin: 5.2em 5.1em;
    transform-origin: 5.2em 5.1em;
    -webkit-animation: load2 2s infinite ease 1.5s;
    animation: load2 2s infinite ease 1.5s;
  }
  .loader:after {
    width: 5.2em;
    height: 10.2em;
    background: #000;
    border-radius: 0 10.2em 10.2em 0;
    top: -0.1em;
    left: 5.1em;
    -webkit-transform-origin: 0px 5.1em;
    transform-origin: 0px 5.1em;
    -webkit-animation: load2 2s infinite ease;
    animation: load2 2s infinite ease;
  }
  @-webkit-keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/modules/helpers/Loading.vue